module.exports = __webpack_public_path__ + "img/telegram.04614e52.svg";